module.exports = __webpack_public_path__ + "img/Vector12.47c31ebb.svg";